import { Card, Form } from 'antd';
import React from 'react'

function CheckInformation({data}) {
  return (
    <Card title="Check Information">
      <Form colon={false} labelCol={{ span: 8 }} wrapperCol={{ span: 8}}>
        <Form.Item label="Next Check Number">
            <p>{data?.nextCheckNumber}</p>
        </Form.Item>
        <Form.Item label="Company Name">
            <p>{data?.companyName}</p>
        </Form.Item>
        <Form.Item label="Company Address">
            <p>{data?.companyAddress}</p>
        </Form.Item>
      </Form>
    </Card>
  )
}

export default CheckInformation;
